module.exports = __webpack_public_path__ + "img/menu-icon-white.fe750964.svg";